import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Bell, Check, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
    const [items, setItems] = useState([]);
    const [showUnreadOnly, setShowUnreadOnly] = useState(false);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        api.get(`/notifications?unread_only=${showUnreadOnly ? "true" : "false"}&limit=100`)
            .then(({ data }) => setItems(data.items || []))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, [showUnreadOnly]); // eslint-disable-line

    const markAll = async () => {
        await api.post("/notifications/mark-read", { mark_all: true });
        toast.success("All marked read");
        load();
    };

    return (
        <div className="p-6 max-w-3xl" data-testid="notifications-page">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <div className="text-xs uppercase tracking-widest text-muted-foreground">Notifications</div>
                    <h1 className="text-2xl tracking-tight mt-1">Activity</h1>
                </div>
                <div className="flex items-center gap-2">
                    <label className="flex items-center gap-1 text-xs text-muted-foreground cursor-pointer">
                        <input type="checkbox" checked={showUnreadOnly} onChange={(e) => setShowUnreadOnly(e.target.checked)} />
                        Unread only
                    </label>
                    <button onClick={markAll} className="border border-border px-3 py-1.5 text-xs flex items-center gap-1" data-testid="mark-all-read">
                        <CheckCheck size={12} /> Mark all read
                    </button>
                </div>
            </div>

            {loading ? <div className="text-sm text-muted-foreground">Loading…</div> : items.length === 0 ? (
                <div className="border border-dashed border-border p-10 text-center" data-testid="notifications-empty">
                    <Bell size={32} className="mx-auto mb-3 text-muted-foreground" />
                    <div className="text-sm">No notifications</div>
                </div>
            ) : (
                <div className="border border-border divide-y divide-border">
                    {items.map((n) => (
                        <div key={n.id} className={`p-3 flex items-start gap-3 ${n.read ? "" : "bg-secondary/40"}`} data-testid={`notif-${n.id}`}>
                            <div className={`w-1 h-full ${n.read ? "bg-transparent" : "bg-blue-600"}`} />
                            <div className="flex-1">
                                <div className="text-sm font-medium">{n.title}</div>
                                {n.body && <div className="text-xs text-muted-foreground mt-0.5">{n.body}</div>}
                                <div className="text-[10px] text-muted-foreground mt-1">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
                            </div>
                            {n.link && <Link to={n.link} className="text-xs underline">Open</Link>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
